import { Modal } from 'farmhub-ui-core';
import styled from 'styled-components';

import { device } from 'styled';

export const CModal = styled(Modal)`
  width: calc(100vw - 24px) !important;
  aspect-ratio: 5 / 3;

  @media ${device.sm} {
    width: 85vw !important;
  }

  @media ${device.lg} {
    width: 920px !important;
  }

  .ant-modal-close {
    width: 36px;
    height: 36px;
    background: #ffffff;

    border-radius: 50%;

    top: 12px;
    right: 12px;

    @media ${device.lg} {
      top: -36px;
      right: -36px;
    }

    .ant-modal-close-x {
      width: 38px;
      height: 38px;

      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .ant-modal-content {
    width: calc(100vw - 24px) !important;
    aspect-ratio: 5 / 3;

    height: 100%;
    border-radius: 6px;
    overflow: visible !important;

    @media ${device.sm} {
      width: 85vw !important;
    }

    @media ${device.lg} {
      width: 920px !important;
    }

    .ant-modal-header {
      display: none;
    }

    .ant-modal-body {
      height: 100%;
      padding: 6px;
    }
  }
`;
